<mat-card (click)="openBottomSheet($event)">
  <div *ngIf="!mobile; else mobileLayout" class="card-screen-full">
    <div class="history-content">
      {{ gatesMonitor?.responsable?.name }}
      <div class="subtitle">
        {{ gatesMonitor.profile[0] ? gatesMonitor.profile[0] : undefined }}
      </div>
    </div>
    <div class="history-content">
      <div class="childs">
        {{ (gatesMonitor?.child)!.name }}
        <div class="subtitle">{{ classRoomDescription }}</div>
      </div>
    </div>
    <div
      class="history-content"
      *ngIf="!gatesMonitor?.isResponsable; else authUnavailable"
    >
      {{ gatesMonitor?.authorized?.name }}
      <div class="subtitle">
        <span class="cpf-space">CPF:</span
        >{{ gatesMonitor?.authorized?.document! | maskCpf }}
      </div>
    </div>
    <ng-template #authUnavailable>
      <div class="history-content">indisponível</div>
    </ng-template>
    <div
      class="history-content"
      *ngIf="gatesMonitor?.status !== 'CANCELED'; else employeeIfCanceled"
    >
      {{ gatesMonitor?.employee?.name }}
    </div>
    <ng-template #employeeIfCanceled>
      <div class="history-content"></div>
    </ng-template>
    <div class="history-content vehicle-col">
      <div class="vehicle" *ngIf="gatesMonitor?.status !== 'CANCELED'">
        <div class="not-canceled"></div>
        <div class="icon-vehicle">
          {{ gatesMonitor?.dtUpdated | date : "H:mm" }}
          <span class="material-icons">
            {{ iconVehicle }}
          </span>
        </div>
      </div>
      <div class="vehicle-canceled" *ngIf="gatesMonitor?.status === 'CANCELED'">
        <div class="canceled">Cancelado</div>
        <div class="icon-vehicle">
          <span class="material-icons">{{ iconVehicle }}</span>
        </div>
      </div>
    </div>
  </div>
  <ng-template #mobileLayout>
    <div class="card-screen-mobile">
      <div class="accordion">
        <span class="material-icons btn-arrow">expand_more</span>
        <div class="canceled" *ngIf="gatesMonitor?.status === 'CANCELED'">
          Cancelado
        </div>
        <div class="history-title">Responsável</div>
        <div class="history-content-mobile">
          {{ gatesMonitor?.responsable?.name }}
          <div class="subtitle-mobile">
            {{ gatesMonitor.profile[0] ? gatesMonitor.profile[0] : undefined }}
          </div>
        </div>
      </div>
      <div class="panel">
        <div class="history-title">Aluno</div>
        <div class="history-content-mobile">
          <div class="childs-mobile">
            {{ (gatesMonitor?.child)!.name }}
            <div class="subtitle-mobile">
              {{ classRoomDescription }}
            </div>
          </div>
        </div>
        <div class="history-title">Autorização</div>
        <div
          class="history-content-mobile"
          *ngIf="!gatesMonitor?.isResponsable; else authUnavailable"
        >
          {{ gatesMonitor?.authorized?.name }}
          <div class="cpf-space-mobile">
            CPF: {{ gatesMonitor?.authorized?.document! | maskCpf }}
          </div>
        </div>
        <ng-template #authUnavailable>
          <div class="cpf-space-unavailable-mobile">indisponível</div>
        </ng-template>
        <div *ngIf="gatesMonitor?.status !== 'CANCELED'">
          <div class="history-title">Funcionário</div>
          <div class="history-content-mobile">
            {{ gatesMonitor?.employee?.name }}
          </div>
        </div>
        <div class="vehicle" *ngIf="gatesMonitor?.status !== 'CANCELED'">
          <div class="not-canceled"></div>
          <div class="icon-vehicle">
            {{ gatesMonitor?.dtUpdated | date : "H:mm" }}
            <span class="material-icons">
              {{ iconVehicle }}
            </span>
          </div>
        </div>
        <div
          class="vehicle-canceled"
          *ngIf="gatesMonitor?.status === 'CANCELED'"
        >
          <div class="icon-vehicle">
            <span class="material-icons">{{ iconVehicle }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</mat-card>
